var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPhotoDocumentation = function SvgIconPhotoDocumentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_91939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_91939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 19V4.99997H3V19H1ZM5 19V4.99997H7V19H5ZM11 19C10.45 19 9.97917 18.8041 9.5875 18.4125C9.19583 18.0208 9 17.55 9 17V6.99997C9 6.44997 9.19583 5.97914 9.5875 5.58747C9.97917 5.1958 10.45 4.99997 11 4.99997H21C21.55 4.99997 22.0208 5.1958 22.4125 5.58747C22.8042 5.97914 23 6.44997 23 6.99997V17C23 17.55 22.8042 18.0208 22.4125 18.4125C22.0208 18.8041 21.55 19 21 19H11ZM12 15H20L17.4 11.5L15.5 14L14.1 12.15L12 15Z",
    fill: "#05072C"
  }))));
};
export default SvgIconPhotoDocumentation;